module.exports = __webpack_public_path__ + "img/69.8.TSS.d6bd42dc.png";